export enum SoSourceEnum {
  TRAVEL_WEBSHOP = 'travel-webshop',
  JEFTINIJE_TRAVEL = 'jeftinije_travel'
}

export const isJeftinijeSource = (source?: string | null): boolean =>
  source === SoSourceEnum.JEFTINIJE_TRAVEL;
